import { useEffect, useState } from 'react'
import { fetchPoolOverviewCTO } from '@react/fetchers/PoolFetchers'
import { PoolDynamicOverviewCTO } from '@shared/PoolDynamicCTO'

export function usePoolOverview(
  serverApiBaseUrl?: string,
  restAPIKey?: string,
  poolAddr?: string,
  refreshKey: number = 0
) {
  const [overview, setOverview] = useState<PoolDynamicOverviewCTO | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    let isMounted = true
    async function fetchData() {
      setLoading(true)
      setError(null)
      try {
        if (serverApiBaseUrl && restAPIKey && poolAddr) {
          const data = await fetchPoolOverviewCTO(serverApiBaseUrl, restAPIKey, poolAddr)
          if (isMounted) setOverview(data as PoolDynamicOverviewCTO)
        }
      } catch (e: any) {
        if (isMounted) setError(e)
        setOverview(null)
      } finally {
        if (isMounted) setLoading(false)
      }
    }
    fetchData()
    return () => {
      isMounted = false
    }
  }, [serverApiBaseUrl, restAPIKey, poolAddr, refreshKey])

  return { overview, loading, error }
}
